import React from 'react'
import { cn } from '../../lib/utils'

const Sidebar = React.forwardRef(({ className, children, width = 200, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'fixed left-0 top-0 z-40 h-full bg-card border-r border-border shadow-sm',
      className
    )}
    style={{ width }}
    {...props}
  >
    {children}
  </div>
))
Sidebar.displayName = 'Sidebar'

const SidebarContent = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex flex-col h-full', className)}
    {...props}
  >
    {children}
  </div>
))
SidebarContent.displayName = 'SidebarContent'

const SidebarHeader = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('p-4 border-b border-border', className)}
    {...props}
  >
    {children}
  </div>
))
SidebarHeader.displayName = 'SidebarHeader'

const SidebarNav = React.forwardRef(({ className, children, ...props }, ref) => (
  <nav
    ref={ref}
    className={cn('flex-1 p-2', className)}
    {...props}
  >
    {children}
  </nav>
))
SidebarNav.displayName = 'SidebarNav'

const SidebarNavItem = React.forwardRef(({ className, children, active, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'flex items-center px-3 py-2 text-sm font-medium rounded-md cursor-pointer transition-colors hover:bg-accent hover:text-accent-foreground',
      active && 'bg-accent text-accent-foreground',
      className
    )}
    {...props}
  >
    {children}
  </div>
))
SidebarNavItem.displayName = 'SidebarNavItem'

const SidebarFooter = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('p-4 border-t border-border', className)}
    {...props}
  >
    {children}
  </div>
))
SidebarFooter.displayName = 'SidebarFooter'

const MainContent = React.forwardRef(({ className, children, sidebarWidth = 200, ...props }, ref) => (
  <main
    ref={ref}
    className={cn('flex-1 p-4', className)}
    style={{ marginLeft: sidebarWidth }}
    {...props}
  >
    {children}
  </main>
))
MainContent.displayName = 'MainContent'

export {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarNav,
  SidebarNavItem,
  SidebarFooter,
  MainContent,
} 